<div class="d-flex align-middle">
  <div class="title">
    <h5>{{ title }}</h5>
  </div>
  <div class="file">
    <p class="text-end">
      <small>{{ patientAttachment.fileName }}</small>
    </p>
  </div>
</div>
